//vo
//import gameIntroSrc from "assets/audio/vo/Game_Intro.mp3";
import WithMeRichard from "assets/audio/vo/01-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import Welcome1 from "assets/audio/vo/02-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import Welcome2 from "assets/audio/vo/03-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AimOfGame from "assets/audio/vo/04-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AimOfGame2 from "assets/audio/vo/AimOfGame.mp3";
import AimOfGameLong from "assets/audio/vo/05-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AimOfGameLong2 from "assets/audio/vo/AimOfGame2.mp3";
import SeeIfRight1 from "assets/audio/vo/06-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import SeeIfRight2 from "assets/audio/vo/07-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import SeeIfRight3 from "assets/audio/vo/08-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import SeeIfRight4 from "assets/audio/vo/09-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import SeeIfRight5 from "assets/audio/vo/10-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import SeeIfRight6 from "assets/audio/vo/RevealAnswer1.mp3";
import SeeIfRight7 from "assets/audio/vo/RevealAnswer2.mp3";
import ItsRight1 from "assets/audio/vo/11-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsRight2 from "assets/audio/vo/12-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsRight3 from "assets/audio/vo/13-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsRight4 from "assets/audio/vo/14-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsRight5 from "assets/audio/vo/CorrectAnswer1.mp3";
import ItsRight6 from "assets/audio/vo/CorrectAnswer2.mp3";
import ReadyForNextQuestion1 from "assets/audio/vo/15-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ReadyForNextQuestion2 from "assets/audio/vo/16-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless1 from "assets/audio/vo/17-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless2 from "assets/audio/vo/18-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless3 from "assets/audio/vo/19-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless4 from "assets/audio/vo/20-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless5 from "assets/audio/vo/21-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless6 from "assets/audio/vo/22-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import ItsPointless7 from "assets/audio/vo/RO-Pointless2.mp3";
import ItsPointless8 from "assets/audio/vo/RO-Pointless3.mp3";
import ItsPointless9 from "assets/audio/vo/PointlessAnswer1.mp3";
import ItsPointless10 from "assets/audio/vo/PointlessAnswer2.mp3";
import AmazingAnswer1 from "assets/audio/vo/23-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AmazingAnswer2 from "assets/audio/vo/24-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AmazingAnswer3 from "assets/audio/vo/25-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AmazingAnswer4 from "assets/audio/vo/26-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import AmazingAnswer5 from "assets/audio/vo/RO-Correct1.mp3";
import AmazingAnswer6 from "assets/audio/vo/RO-GreatAnswer1.mp3";
import AmazingAnswer7 from "assets/audio/vo/RO-GreatAnswer2.mp3";
import AmazingAnswer8 from "assets/audio/vo/RO-GreatAnswer3.mp3";
import AmazingAnswer9 from "assets/audio/vo/RO-GreatAnswer4.mp3";
import AmazingAnswer10 from "assets/audio/vo/AmazingAnswer1.mp3";
import AmazingAnswer11 from "assets/audio/vo/AmazingAnswer2.mp3";
import AmazingAnswer12 from "assets/audio/vo/AmazingAnswer3.mp3";
import AmazingAnswer13 from "assets/audio/vo/AmazingAnswer4.mp3";
import OkAnswer1 from "assets/audio/vo/27-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import OkAnswer2 from "assets/audio/vo/28-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import OkAnswer3 from "assets/audio/vo/RO-AverageAnswer.mp3";
import OkAnswer4 from "assets/audio/vo/RO-AverageAnswer-2.mp3";
import NotGreatAnswer1 from "assets/audio/vo/29-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import NotGreatAnswer2 from "assets/audio/vo/30-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import NotGreatAnswer3 from "assets/audio/vo/31-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import NotGreatAnswer4 from "assets/audio/vo/OkAnswer1.mp3";
import NotGreatAnswer5 from "assets/audio/vo/OkAnswer2.mp3";
import NotGreatAnswer6 from "assets/audio/vo/OkAnswer3.mp3";
import WrongAnswer1 from "assets/audio/vo/32-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import WrongAnswer2 from "assets/audio/vo/33-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import WrongAnswer3 from "assets/audio/vo/34-POINTLESS GAME VO XANDER RX 27.09.18.mp3";
import WrongAnswer4 from "assets/audio/vo/WrongAnswer1.mp3";
import WrongAnswer5 from "assets/audio/vo/WrongAnswer2.mp3";
import WrongAnswer6 from "assets/audio/vo/WrongAnswer3.mp3";
import EndOfRounds from "assets/audio/vo/EndOfPodiumRounds.mp3";
import FinalNotPointless1 from "assets/audio/vo/Final-NotPointless1.mp3";
import FinalNotPointless2 from "assets/audio/vo/Final-NotPointless2.mp3";
import FinalNotPointless3 from "assets/audio/vo/Final-NotPointless3.mp3";
import FinalNotPointless4 from "assets/audio/vo/Final-NotPointless4.mp3";
import FinalChooseCategory from "assets/audio/vo/FinalRound-ChooseCategory.mp3";
import FinalStarted from "assets/audio/vo/Final-Started.mp3";
import FinalGiveMeAnswers from "assets/audio/vo/FinalRound-GiveMeAnswers.mp3";
import FinalGiveMeAnswers2 from "assets/audio/vo/FinalRound-GiveMeAnswers-2.mp3";
import FinalIntro from "assets/audio/vo/FinalRound-Intro.mp3";
import FinalIntrov2 from "assets/audio/vo/FinalRound-Intro-2.mp3";
import FinalIntrov3 from "assets/audio/vo/FinalRound-Intro-3.mp3";
import FinalIntro1 from "assets/audio/vo/FinalIntro1.mp3";
import FinalIntro1v2 from "assets/audio/vo/FinalIntro1-2.mp3";
import FinalIntro2 from "assets/audio/vo/FinalIntro2.mp3";
import FinalIntro2v2 from "assets/audio/vo/FinalIntro2-2.mp3";
import FinalFirstAnswer from "assets/audio/vo/FinalFirstAnswer.mp3";
import FinalSecondAnswer from "assets/audio/vo/FinalSecondAnswer.mp3";
import FinalThirdAnswer from "assets/audio/vo/FinalThirdAnswer.mp3";
import FinalSelectThree from "assets/audio/vo/FinalRound-SelectThree.mp3";
import FinalYouLose from "assets/audio/vo/Final-YouLose.mp3";
import FinalYouWin from "assets/audio/vo/Final-YouWin.mp3";
import Podium1Turn from "assets/audio/vo/Podium1-YourTurn.mp3";
import Podium2Turn from "assets/audio/vo/Podium2-YourTurn.mp3";
import Podium3Turn from "assets/audio/vo/Podium3-YourTurn.mp3";
import Podium4Turn from "assets/audio/vo/Podium4-YourTurn.mp3";
import FirstQuestion from "assets/audio/vo/PodiumFirstQuestion.mp3";
import PossibleAnswers1 from "assets/audio/vo/RO-ShowAnswers.mp3";
import PossibleAnswers2 from "assets/audio/vo/RO-AnswersCouldHaveHad.mp3";
import PossibleAnswers3 from "assets/audio/vo/RO-ShallWeSeeAnswers.mp3";
import PossibleAnswers4 from "assets/audio/vo/RO-ShallWeSeeAnswers-2.mp3";
import PossibleAnswers5 from "assets/audio/vo/RO-ShallWeSeeAnswers-3.mp3";
import PossibleAnswers6 from "assets/audio/vo/RO-ShallWeSeeAnswers-4.mp3";
import Podium1Turn1 from "assets/audio/vo/YourTurnPodium1-1.mp3";
import Podium1Turn2 from "assets/audio/vo/YourTurnPodium1-2.mp3";
import Podium1Turn3 from "assets/audio/vo/YourTurnPodium1-3.mp3";
import Podium1Turn4 from "assets/audio/vo/YourTurnPodium1-4.mp3";
import Podium2Turn1 from "assets/audio/vo/YourTurnPodium2-1.mp3";
import Podium2Turn2 from "assets/audio/vo/YourTurnPodium2-2.mp3";
import Podium2Turn3 from "assets/audio/vo/YourTurnPodium2-3.mp3";
import Podium3Turn1 from "assets/audio/vo/YourTurnPodium3-1.mp3";
import Podium3Turn2 from "assets/audio/vo/YourTurnPodium3-2.mp3";
import Podium3Turn3 from "assets/audio/vo/YourTurnPodium3-3.mp3";
import Podium4Turn1 from "assets/audio/vo/YourTurnPodium4-1.mp3";
import Podium4Turn2 from "assets/audio/vo/YourTurnPodium4-2.mp3";
import Podium4Turn3 from "assets/audio/vo/YourTurnPodium4-3.mp3";
import Podium4Turn4 from "assets/audio/vo/YourTurnPodium4-4.mp3";
import CategoryComment1 from "assets/audio/vo/categoryComment1.mp3";
import CategoryComment2 from "assets/audio/vo/categoryComment2.mp3";
import CategoryComment3 from "assets/audio/vo/categoryComment3.mp3";
import CategoryComment4 from "assets/audio/vo/categoryComment4.mp3";
import Category1 from "assets/audio/vo/category-1.mp3";
import Category1v2 from "assets/audio/vo/category-1-2.mp3";
import Category2 from "assets/audio/vo/category-2.mp3";
import Category2v2 from "assets/audio/vo/category-2-2.mp3";
import Category3 from "assets/audio/vo/category-3.mp3";
import Category3v2 from "assets/audio/vo/category-3-2.mp3";
import Category4 from "assets/audio/vo/category-4.mp3";
import Category4v2 from "assets/audio/vo/category-4-2.mp3";
import NextQuestionSingle1 from "assets/audio/vo/next-question-single-1.mp3";
import NextQuestionSingle2 from "assets/audio/vo/next-question-single-2.mp3";
import NextQuestionSingle3 from "assets/audio/vo/next-question-single-3.mp3";
import NextQuestionGroup1 from "assets/audio/vo/next-question-group-1.mp3";
import NextQuestionGroup2 from "assets/audio/vo/next-question-group-2.mp3";
import NextQuestionGroup3 from "assets/audio/vo/next-question-group-3.mp3";
import Podium1FinalCategory from "assets/audio/vo/Podium1_FinalCategory.mp3";
import Podium2FinalCategory from "assets/audio/vo/Podium2_FinalCategory.mp3";
import Podium3FinalCategory from "assets/audio/vo/Podium3_FinalCategory.mp3";
import Podium4FinalCategory from "assets/audio/vo/Podium4_FinalCategory.mp3";

//sfx
import AnswerWrong from "assets/audio/SFX/COUNTER_AnswerWrong.mp3";
import CounterStop from "assets/audio/SFX/COUNTER_CounterStopsRounds1to3.mp3"
import FinalRoundCounter from "assets/audio/SFX/COUNTER_EndGameCounter_NoSting.mp3"
import CounterPassLine from "assets/audio/SFX/COUNTER_PassingTheLineTing.mp3"
import PointlessSting from "assets/audio/SFX/COUNTER_PointlessSting_R1to3.mp3"
import RoundsCounter from "assets/audio/SFX/COUNTER_R1to3_Original.mp3"
import RoundsCounterSoftEnd from "assets/audio/SFX/COUNTER_R1to3_SoftEndAt7sec.mp3"
import DisplaySweep from "assets/audio/SFX/SFX_DisplaySweep.mp3"
import ScoreUpdate from "assets/audio/SFX/SFX_ScoreUpdate.mp3"
import Tok from "assets/audio/SFX/Tok.mp3"

//music
import PreCreditsTheme from "assets/audio/music/BED_ThemeUnderscore_PreCredits.mp3";
import StingRound1And2 from "assets/audio/music/STING_Round1&2_FULL.mp3";
import StingRichardIntro from "assets/audio/music/STING_RichardIntro.mp3";
import StingContestantsSwap from "assets/audio/music/STING_ContestantsSwapAround.mp3"
import TensionBed from "assets/audio/music/BED_PointlessFinal_Tension.mp3"

// shape:
//{
//    src: srcFile|[srcFile, fallbackFile],
//    volume: 0.4,
//    loop: false|true
//},

export const VO = {
    WithMeRichard: { src: WithMeRichard, volume: 0.5, preload: true },
    Welcome: [
        { src: Welcome1, volume: 0.5, preload: true },
        { src: Welcome2, volume: 0.5, preload: true },
    ],
    AimOfGame: [
        { src: AimOfGame, volume: 0.5, preload: true },
        { src: AimOfGame2, volume: 0.5, preload: true },
        { src: AimOfGameLong, volume: 0.5, preload: true },
        { src: AimOfGameLong2, volume: 0.5, preload: true },
    ],
    SeeIfRight: [
        { src: SeeIfRight1, volume: 0.5, preload: true },
        { src: SeeIfRight2, volume: 0.5, preload: true },
        { src: SeeIfRight3, volume: 0.5, preload: true },
        { src: SeeIfRight4, volume: 0.5, preload: true },
        { src: SeeIfRight5, volume: 0.5, preload: true },
        { src: SeeIfRight6, volume: 0.5, preload: true },
        { src: SeeIfRight7, volume: 0.5, preload: true },
    ],
    ItsRight: [
        { src: ItsRight1, volume: 0.5, preload: true },
        { src: ItsRight2, volume: 0.5, preload: true },
        { src: ItsRight3, volume: 0.5, preload: true },
        { src: ItsRight4, volume: 0.5, preload: true },
        { src: ItsRight5, volume: 0.5, preload: true },
        { src: ItsRight6, volume: 0.5, preload: true },
    ],
    ReadyForNextQuestion: [
        { src: ReadyForNextQuestion1, volume: 0.5, preload: true },
        { src: ReadyForNextQuestion2, volume: 0.5, preload: true },
    ],
    ItsPointless: [
        { src: ItsPointless1, volume: 0.5, preload: true },
        { src: ItsPointless2, volume: 0.5, preload: true },
        { src: ItsPointless3, volume: 0.5, preload: true },
        { src: ItsPointless4, volume: 0.5, preload: true },
        { src: ItsPointless5, volume: 0.5, preload: true },
        { src: ItsPointless6, volume: 0.5, preload: true },
        { src: ItsPointless7, volume: 0.5, preload: true },
        { src: ItsPointless8, volume: 0.5, preload: true },
        { src: ItsPointless9, volume: 0.5, preload: true },
        { src: ItsPointless10, volume: 0.5, preload: true },
    ],
    AmazingAnswer: [
        { src: AmazingAnswer1, volume: 0.5, preload: true },
        { src: AmazingAnswer2, volume: 0.5, preload: true },
        { src: AmazingAnswer3, volume: 0.5, preload: true },
        { src: AmazingAnswer4, volume: 0.5, preload: true },
        { src: AmazingAnswer5, volume: 0.5, preload: true },
        { src: AmazingAnswer6, volume: 0.5, preload: true },
        { src: AmazingAnswer7, volume: 0.5, preload: true },
        { src: AmazingAnswer8, volume: 0.5, preload: true },
        { src: AmazingAnswer9, volume: 0.5, preload: true },
        { src: AmazingAnswer10, volume: 0.5, preload: true },
        { src: AmazingAnswer11, volume: 0.5, preload: true },
        { src: AmazingAnswer12, volume: 0.5, preload: true },
        { src: AmazingAnswer13, volume: 0.5, preload: true },
    ],
    OkAnswer: [
        { src: OkAnswer1, volume: 0.5, preload: true },
        { src: OkAnswer2, volume: 0.5, preload: true },
        { src: OkAnswer3, volume: 0.5, preload: true },
        { src: OkAnswer4, volume: 0.5, preload: true },
    ],
    NotGreatAnswer: [
        { src: NotGreatAnswer1, volume: 0.5, preload: true },
        { src: NotGreatAnswer2, volume: 0.5, preload: true },
        { src: NotGreatAnswer3, volume: 0.5, preload: true },
        { src: NotGreatAnswer4, volume: 0.5, preload: true },
        { src: NotGreatAnswer5, volume: 0.5, preload: true },
        { src: NotGreatAnswer6, volume: 0.5, preload: true },
    ],
    WrongAnswer: [
        { src: WrongAnswer1, volume: 0.5, preload: true },
        { src: WrongAnswer2, volume: 0.5, preload: true },
        { src: WrongAnswer3, volume: 0.5, preload: true },
        { src: WrongAnswer4, volume: 0.5, preload: true },
        { src: WrongAnswer5, volume: 0.5, preload: true },
        { src: WrongAnswer6, volume: 0.5, preload: true },
    ],
    EndOfRounds: { src: EndOfRounds, volume: 0.5, preload: true },
    Final: {
        NotPointless: [
            { src: FinalNotPointless1, volume: 0.5, preload: true },
            { src: FinalNotPointless2, volume: 0.5, preload: true },
            { src: FinalNotPointless3, volume: 0.5, preload: true },
            { src: FinalNotPointless4, volume: 0.5, preload: true },
        ],
        ChooseCategory: { src: FinalChooseCategory, volume: 0.5, preload: true }, 
        Started: { src: FinalStarted, volume: 0.5, preload: true },
        GiveMeAnswers: [
            { src: FinalGiveMeAnswers, volume: 0.5, preload: true },
            { src: FinalGiveMeAnswers2, volume: 0.5, preload: true },
        ],
        Intro: [
            { src: FinalIntro, volume: 0.5, preload: true },
            { src: FinalIntrov2, volume: 0.5, preload: true },
            { src: FinalIntrov3, volume: 0.5, preload: true },
        ],
        Intro1: [
            { src: FinalIntro1, volume: 0.5, preload: true },
            { src: FinalIntro1v2, volume: 0.5, preload: true },
        ],
        Intro2: [
            { src: FinalIntro2, volume: 0.5, preload: true },
            { src: FinalIntro2v2, volume: 0.5, preload: true },
        ],
        SelectThree: { src: FinalSelectThree, volume: 0.5, preload: true },
        FirstAnswer: { src: FinalFirstAnswer, volume: 0.5, preload: true },
        SecondAnswer: { src: FinalSecondAnswer, volume: 0.5, preload: true },
        ThirdAnswer: { src: FinalThirdAnswer, volume: 0.5, preload: true },
        YouLose: { src: FinalYouLose, volume: 0.5, preload: true },
        YouWin: { src: FinalYouWin, volume: 0.5, preload: true },
    },
    PossibleAnswers: [
        //{ src: PossibleAnswers1, volume: 0.5, preload: true },
        //{ src: PossibleAnswers2, volume: 0.5, preload: true },
        { src: PossibleAnswers3, volume: 0.5, preload: true },
        { src: PossibleAnswers4, volume: 0.5, preload: true },
        { src: PossibleAnswers5, volume: 0.5, preload: true },
        { src: PossibleAnswers6, volume: 0.5, preload: true },
    ],
    Podiums: {
        FirstQuestion: { src: FirstQuestion, volume: 0.5 },
        Turn: {
            Podium1: [
                { src: Podium1Turn, volume: 0.5, preload: true },
                { src: Podium1Turn1, volume: 0.5, preload: true },
                //{ src: Podium1Turn2, volume: 0.5 , preload: true},
                { src: Podium1Turn3, volume: 0.5, preload: true },
                { src: Podium1Turn4, volume: 0.5, preload: true },
            ],
            Podium2: [
                { src: Podium2Turn, volume: 0.5, preload: true },
                { src: Podium2Turn1, volume: 0.5, preload: true },
                { src: Podium2Turn2, volume: 0.5, preload: true },
                { src: Podium2Turn3, volume: 0.5, preload: true },
            ],
            Podium3: [
                { src: Podium3Turn, volume: 0.5, preload: true },
                { src: Podium3Turn1, volume: 0.5, preload: true },
                { src: Podium3Turn2, volume: 0.5, preload: true },
                { src: Podium3Turn3, volume: 0.5, preload: true },
            ],
            Podium4: [
                { src: Podium4Turn, volume: 0.5, preload: true },
                { src: Podium4Turn1, volume: 0.5, preload: true },
                { src: Podium4Turn2, volume: 0.5, preload: true },
                { src: Podium4Turn3, volume: 0.5, preload: true },
                { src: Podium4Turn4, volume: 0.5, preload: true },
            ],
        },
    },
    NextCategory: [
        [
            { src: Category1, volume: 0.5, preload: true },
            { src: Category1v2, volume: 0.5, preload: true },
        ],
        [
            { src: Category2, volume: 0.5, preload: true },
            { src: Category2v2, volume: 0.5, preload: true },
        ],
        [
            { src: Category3, volume: 0.5, preload: true },
            { src: Category3v2, volume: 0.5, preload: true },
        ],
        [
            { src: Category4, volume: 0.5, preload: true },
            { src: Category4v2, volume: 0.5, preload: true },
        ],
    ],
    CategoryComment: [
        { src: CategoryComment1, volume: 0.5, preload: true },
        { src: CategoryComment2, volume: 0.5, preload: true },
        { src: CategoryComment3, volume: 0.5, preload: true },
        { src: CategoryComment4, volume: 0.5, preload: true },
    ],
    NextQuestionSingle: [
        { src: NextQuestionSingle1, volume: 0.5, preload: true },
        { src: NextQuestionSingle2, volume: 0.5, preload: true },
        { src: NextQuestionSingle3, volume: 0.5, preload: true },
    ],
    NextQuestionGroup: [
        { src: NextQuestionGroup1, volume: 0.5, preload: true },
        { src: NextQuestionGroup2, volume: 0.5, preload: true },
        { src: NextQuestionGroup3, volume: 0.5, preload: true },
    ],
    FinalCategory: [
        { src: Podium1FinalCategory, volume: 0.5, preload: true },
        { src: Podium2FinalCategory, volume: 0.5, preload: true },
        { src: Podium3FinalCategory, volume: 0.5, preload: true },
        { src: Podium4FinalCategory, volume: 0.5, preload: true },
    ]
};

// === SFX ===
export const SFX = {
    AnswerWrong: { src: AnswerWrong, volume: 0.4, preload: true },
    CounterStop: { src: CounterStop, volume: 0.4, preload: true },
    FinalRoundCounter: { src: FinalRoundCounter, volume: 0.4, preload: true },
    CounterPassLine: { src: CounterPassLine, volume: 0.4, preload: true },
    PointlessSting: { src: PointlessSting, volume: 0.4, preload: true },
    RoundsCounter: { src: RoundsCounter, volume: 0.4, preload: true },
    RoundsCounterSoftEnd: { src: RoundsCounterSoftEnd, volume: 0.4, preload: true },
    DisplaySweep: { src: DisplaySweep, volume: 0.4, preload: true },
    ScoreUpdate: { src: ScoreUpdate, volume: 0.4, preload: true },
    Tok: { src: Tok, volume: 0.4, preload: true },
};

// === MUSIC ===
export const MUSIC = {
    PreCreditsTheme: { src: PreCreditsTheme, volume: 0.3, loop: false, preload: true },
    StingRound1And2: { src: StingRound1And2, volume: 0.3, loop: false, preload: true },
    StingRichardIntro: { src: StingRichardIntro, volume: 0.3, loop: false, preload: true },
    StingContestantsSwap: { src: StingContestantsSwap, volume: 0.3, loop: false, preload: true },
    TensionBed: { src: TensionBed, volume: 0.3, loop: false, preload: true },
};

// Helper function to extract audio sources that should be preloaded
export const getPreloadAudio = () => {
    const sources = [];

    const extractFromObject = (obj) => {
        if (!obj) return;

        // If this is an audio definition with src and preload flag
        if (obj.src && obj.preload === true) {
            // Handle both single src and array of src
            if (Array.isArray(obj.src)) {
                sources.push(...obj.src.filter(s => s)); // Filter out empty strings
            } else if (obj.src) {
                sources.push(obj.src);
            }
        }

        // Recursively check nested objects (for ROUND_INTRO case)
        if (typeof obj === 'object' && !obj.src) {
            Object.values(obj).forEach(value => {
                if (typeof value === 'object') {
                    extractFromObject(value);
                }
            });
        }
    };

    // Process all audio types
    [SFX, VO, MUSIC].forEach(audioObj => extractFromObject(audioObj));

    console.log("SOURCES : ", sources);
    return sources;
};